import { moduleProviderFactory } from 'core/providers';
import { ReportEdit, ReportList } from 'modules/report/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.report',
				pattern: '/reports',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.report.list',
						pattern: '',
						authorization: 'reportSection.full',
						component: ReportList,
					},
					{
						name: 'master.app.main.report.list.add-template',
						pattern: '/add-template',
						authorization: 'reportSection.full',
						component: ReportEdit,
					},
					{
						name: 'master.app.main.report.list.add-report',
						pattern: '/add-report',
						authorization: 'reportSection.full',
						component: ReportEdit,
					},
					{
						name: 'master.app.main.report.list.edit',
						pattern: '/edit/:id',
						authorization: 'reportSection.full',
						component: ReportEdit,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/report/config.js